<template>
  <div class="content">
    <div class="left">
      <div class="logo">
        <img src="~@/assets/img/logo.png" alt="logo" @click="toRestsUrl('home')">
      </div>
      <div class="nav-right">
        <div class="navbar-nav">
          <div class="navbar-nav-div"><span :class="(activeIndex == 0 || activeIndex == 4) ? 'active' : ''"
              @click="linkTo(0)">电影票</span></div>
          <div class="navbar-nav-div" v-if="isSaas == 1"><span :class="(activeIndex == 7) ? 'active' : ''"
              @click="linkTo(7)">Saas加盟</span></div>
          <!--              <div class="navbar-nav-div"><span :class="(activeIndex == 1) ? 'active':''" @click="linkTo(1)">我要推广</span></div>-->
          <!--              <div class="navbar-nav-div"><span :class="(activeIndex == 5) ? 'active':''" @click="linkTo(5)">公众号入驻</span></div>-->
          <!--              <div class="navbar-nav-div"><span :class="(activeIndex == 6) ? 'active':''" @click="linkTo(6)">肯德基</span></div>-->
<!--          <div class="navbar-nav-div"><span :class="(activeIndex == 8) ? 'active' : ''" @click="linkTo(8)">品牌商城</span>-->
<!--          </div>-->
          <div class="navbar-nav-div"><span :class="(activeIndex == 88) ? 'active' : ''" @click="linkTo(88)">账户中心</span>
          </div>

          <!-- <div class="navbar-nav-div"><span :class="(activeIndex == 9) ? 'active':''" @click="linkTo(9)">账户中心</span></div> -->
          <div class="navbar-nav-div" v-if="isShowOpen"><span :class="(activeIndex == 2) ? 'active' : ''"
              @click="linkTo(2)">开放平台</span></div>
          <div class="navbar-nav-div"><span :class="(activeIndex == 3 && isShowContact == true) ? 'active' : ''"
              @click="linkTo(3)">联系我们</span></div>
        </div>
        <contact v-show="isShowContact"></contact>
      </div>
    </div>
    <div class="right">

      <div class="user">
        <div class="WXplatform" v-if="isPlatform === true">
          <div class="item">
            <div class="flex">
              <img class="avatar" :src="showAppKey.appImg" alt="">
              <p class="userName">
                {{ showAppKey.appName }}
              </p>
            </div>
            <div class="cut" @click="iscutStatus = !iscutStatus">切换</div>
          </div>

          <div class="location" v-if="iscutStatus">
            <div v-for="(item, index) in appKey" :key="index">
              <div class="item" v-if="item.appName !== showAppKey.appName">
                <div class="flex">
                  <img class="avatar" :src="item.appImg" alt="">
                  <p class="userName">
                    {{ item.appName }}
                  </p>
                </div>
                <div class="cut" @click="cutBtn(index)">切换</div>
              </div>
            </div>

          </div>

        </div>
        <div class="add" @click="toRestsUrl('auth')">添加公众号</div>
        <div class="user">
          <div class="user-div">
            <img class="avatar" v-if="userInfo.avatar" :src="userInfo.avatar" alt="">
            <img class="avatar" v-else src="~@/assets/img/kfc/head.png" alt="">
            <div class="nickname">{{ userInfo ? userInfo.nickname : '' }}</div>
            <span class="exit" @click="userExit">退出</span>
            <!--            <div class="arrow-img">-->
            <!--              <img @click="changeArrow()" :src="this.arrowIcon" alt="">-->
            <!--              <div class="nav-dialog-box" v-if="isShow">-->
            <!--                <span class="bot"></span>-->
            <!--                <span class="top"></span>-->
            <!--                <div class="nav-item">-->
            <!--                  <div @click="toRestsUrl(0)" :class="(activeItem == 0) ? 'active':''">我的推广位</div>-->
            <!--                  <div @click="toRestsUrl(1)" :class="(activeItem == 1) ? 'active':''">影票公众号</div>-->
            <!--                  <div @click="toRestsUrl(4)" :class="(activeItem == 4) ? 'active':''">我的应用</div>-->
            <!--                  <div @click="toRestsUrl(5)" :class="(activeItem == 5) ? 'active':''">saas加盟</div>-->
            <!--                  <div class="noStyle"></div>-->
            <!--&lt;!&ndash;                  <div @click="toRestsUrl(3)" :class="(activeItem == 3) ? 'active':''">肯德基公众号</div>&ndash;&gt;-->
            <!--                  <div @click="toRestsUrl(6)" :class="(activeItem == 6) ? 'active':''">品牌商城</div>-->
            <!--                  <div class="noStyle"></div>-->
            <!--                  <div @click="toRestsUrl(7)" :class="(activeItem == 7) ? 'active':''">账户中心</div>-->
            <!--                  <div @click="toRestsUrl(2)" :class="(activeItem == 2) ? 'active':''">退出账号</div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navArrowDowm from '@/assets/img/kfc/nav_btn_arrow_down.png'
import navArrowUp from '@/assets/img/kfc/nav_btn_arrow_upward.png'
import { Modal } from "view-design";
import { getToken, getUserInfo, getIsDeveloper } from '@/utils/auth'
export default {
  name: 'openNav',
  components: {},
  props: ['isPlatform'],
  data() {
    return {
      isSaas: '',
      imgUrlTest: require('@/assets/img/kfc/head.png'),
      iscutStatus: false,
      userInfo: {},
      isShowAccount: false,
      isShow: false,
      arrowIcon: navArrowDowm,
      listLoading: false,
      publicList: [],
      isShowContact: false,
      needLoginIndex: [1, 2, 88, 7],
    }
  },
  computed: {
    appKey() {
      return this.$store.getters.appKey
    },
    showAppKey() {
      return this.$store.getters.showAppKey
    },
    activeItem: function () {
      return this.$store.getters.personalActiveIndex
    },
    platformName: function () {
      return this.$store.getters.platformNameKfc || ''
    },
    headImg: function () {
      return this.$store.getters.headImgKfc || ''
    },
    activeIndex: function () {
      return this.$store.getters.activeIndex
    },
    isShowOpen: function () {
      //不管是否登录 是否为开发者都显示
      return true
      if (!this.$store.getters.userToken) {
        return true
      } else {
        if (this.$store.getters.isDeveloper) {
          return true
        } else {
          return false
        }
      }
    }
  },
  watch: {},
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem('openUserInfo'))
  },
  mounted() { },
  activated() { },
  deactivated() { },
  destroyed() { },
  methods: {
    toRestsUrl(key) {
      let isSaas = localStorage.getItem('isSaas')
      console.log('isSaas', isSaas)
      if (!isNaN(key)) {
        this.$store.dispatch('nav/changePersonalActiveIndex', key)
      }
      key = key.toString()
      switch (key) {
        case 'home':
          if (isSaas == 1) {
            this.$router.push({ path: '/pc/home', query: { type: 'saasmovie' } })
          } else {
            this.$router.push('/pc/home')
          }
          break
        case 'auth':
          this.$router.push('/pc/open/application')
          this.$store.commit('open/SET_addKfcDialog', true)
          break
        case '0':
          this.$router.push('/pc/promotion/home')
          break
        case '1':
          this.$router.push('/pc/official/mywechat')
          this.$store.dispatch('official/changeIsShowSlide', true)
          this.$store.dispatch('nav/changeOfficialAccountActiveIndex', 1)
          break
        case '2':
          this.$store.dispatch('user/logout')
          this.$Message.success('退出成功')
          this.$router.push('/')
          break
        case '3':
          this.$router.push('/pc/kfc/mywechat')
          break
        case '4':
          this.$router.push('/pc/document/user')
          break
        case '5':
          this.$router.push('/pc/SaasJoin/home/index')
          break
        case '6':
          this.$router.push('/pc/open/application')
          break
        case '7':
          this.$router.push('/pc/user/accountWithdrawal')
          break

        default:
          break
      }
    },
    toHome() {
      let isSaas = localStorage.getItem('isSaas')
      if (isSaas == 1) {
        this.$router.push({ path: '/pc/home', query: { type: 'saasmovie' } })
      } else {
        this.$router.push('/pc/home')
      }
    },
    cutBtn(index) {
      this.$store.commit('user/SET_showAppKey', this.$store.getters.appKey[index])
      this.iscutStatus = false
      this.$message.success('切换至 ' + this.showAppKey.appName)
      localStorage.setItem('lastAppName', this.$store.getters.appKey[index].appName)
    },
    changeArrow() {
      if (this.isShow === false) {
        this.isShow = true
        this.isShowAccount = false
        this.arrowIcon = navArrowUp
      } else {
        this.isShow = false
        this.arrowIcon = navArrowDowm
      }
    },
    linkTo: function (type) {
      console.log("debug:________________type______________", type);
      var isNext = true
      var that = this
      let isSaas = window.localStorage.getItem('isSaas')
      if (this.needLoginIndex.indexOf(type) > -1) {
        var token = getToken()
        console.log('token', token)
        if (token === undefined || token === '') {
          isNext = false
          // 弹窗提示
          Modal.warning({
            title: '提示',
            content: '您还未登录，请先登录！',
            onOk: function () {
              that.$store.dispatch('nav/changeActiveIndex', 0)

              if (type == 7 && isSaas == 1) {
                that.$router.push({
                  path: '/',
                  query: {
                    type: 'saasmovie'
                  }
                })
              } else {
                that.$router.push('/')
              }
            }
          })
        }
      }

      if (isNext == false) {
        return
      }

      if (type === 3) {
        this.isShowContact = !this.isShowContact
      } else {
        this.isShowContact = false
        this.$store.dispatch('nav/changeActiveIndex', type)
        switch (type) {
          case 1:
            this.$router.push('/pc/promotion/home')
            break
          case 2:
            this.$router.push('/pc/document/user')
            break
          case 3:
            this.isShowContact = !this.isShowContact
            break
          case 4:
            this.$router.push('/pc/register')
            break
          case 5:
            this.$router.push('/pc/official/home')
            break
          case 6:
            if (isSaas == 1) {
              that.$router.push({
                path: '/pc/kfc/home',
                query: {
                  type: 'saasmovie'
                }
              })
            } else {
              that.$router.push({
                path: '/pc/kfc/home',
              })
            }
            break
          case 7:
            this.$router.push('/pc/SaasJoin/home/index')
            break
          case 8:
            if (isSaas == 1) {
              that.$router.push({
                path: '/pc/open/home',
                query: {
                  type: 'saasmovie'
                }
              })
            } else {
              that.$router.push({
                path: '/pc/open/home',
              })
            }
            break
          case 88:
            this.$router.push('/pc/user/accountWithdrawal')
            break
          case 0:
            if (isSaas == 1) {
              that.$router.push({
                path: '/',
                query: {
                  type: 'saasmovie'
                }
              })
            } else {
              that.$router.push({
                path: '/',
              })
            }
            this.$store.dispatch('nav/changeMovieShowDialog', true)
            break
        }
      }
    },
    userExit() {
      this.$store.dispatch('nav/changeIsGoOfficial', 0)
      this.$store.dispatch('user/logout')
      this.$Message.success('退出成功')
      if (this.isSaas == 1) {
        this.$router.push({
          path: '/',
          query: {
            type: 'saasmovie'
          }
        })
      } else {
        this.$router.push({
          path: '/',
        })
      }
    },
  }
}
</script>
<style lang='less' scoped>
.content {
  margin: 0 2.5%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // max-width: 1400px;

  .logo {
    width: 178px;
    height: 80px;
    background: #ff8622;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;

    img {
      width: 100%;
    }
  }

  .user {
    height: 100%;
    display: flex;
    align-items: center;

    .cut {
      margin-left: 10px;
      font-size: 12px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #3d9efc;
      line-height: 17px;
      cursor: pointer;
    }

    .add {
      margin-left: 10px;
      width: 84px;
      height: 28px;
      background: #ff8622;
      border-radius: 2px;
      font-size: 12px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #ffffff;
      line-height: 28px;
      text-align: center;
      cursor: pointer;
    }

    .avatar {
      margin-left: 40px;
      width: 32px;
      height: 32px;
      border-radius: 16px;
      cursor: pointer;
    }

    .userName {
      margin-left: 6px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      line-height: 20px;
      cursor: pointer;
    }

    .arrow-img {
      margin-left: 5px;
      width: 20px;
      cursor: pointer;

      img {
        width: 100%;
      }
    }

    .WXplatform {
      z-index: 99;
      height: 100%;
      width: 180px;
      display: flex;
      // justify-content: space-between;
      align-items: center;
      position: relative;

      // border: 1px solid red;
      .cut {
        min-width: 32px;
        margin-left: 10px;
        font-size: 12px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #3d9efc;
        line-height: 17px;
        cursor: pointer;
      }

      .avatar {
        width: 32px;
        height: 32px;
        border-radius: 16px;
        margin-left: 0px;
        // cursor: pointer;
      }

      .userName {
        flex: 1;
        margin-left: 10px;
        min-width: 0;
        // margin-right: 40px;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        // cursor: pointer;
      }

      .location {
        width: 100%;
        position: absolute;
        top: 65px;
        right: 0;
        // background-color: white;
      }

      .item {
        // border: 1px solid red;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 55px;
        padding-left: 10px;
        background-color: white;

        .flex {
          width: 75%;
          // flex: 1;
          display: flex;
          align-items: center;
        }
      }
    }

    .exit {
      margin-left: 10px;
      //color: blue;
      cursor: pointer;
      font-size: 14px;
    }
  }
}

.left {
  display: flex;
  align-items: center;
}

.user {
  float: right;
  height: 80px;
  font-size: 16px;
  color: #666666;

  .user-div {
    height: 80px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .avatar {
    width: 32px;
    height: 32px;
    border-radius: 16px;
  }

  .nickname {
    font-size: 13px;
    color: #666666;
    max-width: 80px;
    margin: 0 5px;
    overflow: hidden;
    white-space: nowrap;
    word-break: break-all;
    text-overflow: clip;
    text-overflow: ellipsis;
  }

  .arrow-img {
    width: 20px;
    cursor: pointer;
    position: relative;

    img {
      width: 100%;
    }
  }
}

.nav-dialog-box {
  background: #ffffff;
  width: 100px;
  position: absolute;
  bottom: -10px;
  left: -40px;
  border-top: 1px solid #eeeeee;

  span {
    width: 0;
    height: 0;
    font-size: 0;
    overflow: hidden;
    position: absolute;
  }

  .bot {
    border-width: 8px;
    border-style: solid dashed dashed;
    border-color: transparent transparent #eeeeee transparent;
    left: 44%;
    top: -16px;
  }

  .top {
    border-width: 8px;
    border-style: solid dashed dashed;
    border-color: transparent transparent #ffffff transparent;
    left: 44%;
    top: -15px;
  }

  .nav-item {
    position: absolute;
    width: 100%;
    text-align: center;
    font-size: 13px;
    color: #666666;
    line-height: 36px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    border-top: none;
    z-index: 999;
    cursor: pointer;

    div {
      height: 36px;
    }

    .active {
      background: #fcfaf8;
      color: #d63036;
    }
  }
}

.kfc-dialog-box {
  background: #ffffff;
  width: 160px;
  position: relative;
  top: 8px;
  border-top: 1px solid #eeeeee;

  span {
    width: 0;
    height: 0;
    font-size: 0;
    overflow: hidden;
    position: absolute;
  }

  .bot {
    border-width: 8px;
    border-style: solid dashed dashed;
    border-color: transparent transparent #eeeeee transparent;
    left: 44%;
    top: -16px;
  }

  .top {
    border-width: 8px;
    border-style: solid dashed dashed;
    border-color: transparent transparent #ffffff transparent;
    left: 44%;
    top: -15px;
  }

  .kfc-item {
    position: absolute;
    width: 100%;
    text-align: center;
    font-size: 13px;
    color: #666666;
    line-height: 36px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    border-top: none;
    z-index: 999;

    .kfc-item-div {
      display: flex;
      flex-direction: row;
      align-items: center;

      img {
        margin: 8px 0 8px 8px;
      }

      .item-change {
        color: #3d9efc;
        cursor: pointer;
      }
    }

    img {
      width: 32px;
      height: 32px;
      border-radius: 16px;
    }

    .active {
      background: #fcfaf8;
      color: #d63036;
    }
  }
}

.noStyle {
  cursor: initial;
}

.nav-right {
  float: right;
}

.nav-right .navbar-nav {
  float: right;
  /* font-family: Alibaba-PuHuiTi-R; */
  font-size: 16px;
  color: #666666;
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  align-items: center;
  text-align: center;
}

.nav-right .navbar-nav .navbar-nav-div {
  float: left;
  margin: 0 25px;
  /* min-width: 65px; */
  white-space: nowrap;
  font-size: 15px;
}

.nav-right .navbar-nav .navbar-nav-div:last-child {
  float: left;
  margin-right: 0;
  /* min-width: 65px; */
  white-space: nowrap;
}

.nav-right .navbar-nav .navbar-nav-div span {
  cursor: pointer;
}

.nav-right .navbar-nav .navbar-nav-div span.active {
  color: #ff9734;
}

.nav-right .navbar-nav .navbar-nav-div .register {
  color: #ff9734;
  border: 1px solid #ff9734;
  border-radius: 15px;
  padding: 4px 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/open/openNav.vue